import { useGetAiWorkspaceRequests } from "@entities/aiWorkspace";
import { useEffect, useRef } from "react";
import { aiWorkspaceRequestId } from "../useAiWorkspaceModuleParams";

export function useSingleScriptGenerateRequest(
  workspaceId: string,
  requestId: string | undefined,
  onOpenRequest?: (id: string, type: string) => void
) {
  const { data, isFetching } = useGetAiWorkspaceRequests(workspaceId);
  const knownIds = (data?.data || [])
    .filter((request) => request.type === "script-generate")
    .sort((a, b) => +new Date(b.updatedAt) - +new Date(a.updatedAt))
    .map((request) => aiWorkspaceRequestId(request))
    .filter(Boolean);
  const latestId = knownIds[0] || "";
  const requestIsKnown = Boolean(requestId && knownIds.includes(requestId));
  const activeId =
    requestId && !requestIsKnown ? requestId : latestId || requestId || "";

  const openRef = useRef(onOpenRequest);
  openRef.current = onOpenRequest;

  useEffect(() => {
    if (isFetching || !activeId || activeId === requestId) return;
    openRef.current?.(activeId, "script-generation");
  }, [activeId, isFetching, requestId]);

  return {
    activeId,
    isResolving: isFetching && !activeId,
  };
}
